/* eslint-disable jsx-a11y/heading-has-content */
import ReactMarkdown, { Components, Options } from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { FigmaTypography } from "@libs/zapi-ui/custom";

export const markdownComponents: Components = {
  a: ({ node: _node, ...props }) => {
    const isInternal =
      props.href?.startsWith("/") || props.href?.includes("platform.innovera") || props.href?.includes("localhost");
    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a
        {...props}
        {...(isInternal ? {} : { target: "_blank", rel: "noopener noreferrer" })}
        className="underline text-[#3367E5]"
      />
    );
  },
  p: ({ node: _node, ...props }) => <p {...props} className="mb-2 last:mb-0" />,
  ul: ({ node: _node, ...props }) => <ul {...props} className="list-disc pl-5 mb-2 last:mb-0" />,
  ol: ({ node: _node, ...props }) => <ol {...props} className="list-decimal pl-5 mb-2 last:mb-0" />,
  li: ({ node: _node, ...props }) => <li {...props} className="mb-1" />,
  h1: ({ node: _node, color: _color, ...props }) => <FigmaTypography component="h1" variant="memo-heading-2" {...props} className="mb-2" />,
  h2: ({ node: _node, color: _color, ...props }) => <FigmaTypography component="h2" variant="memo-heading-3" {...props} className="mb-2" />,
  h3: ({ node: _node, color: _color, ...props }) => <FigmaTypography component="h3" variant="memo-body-semibold" {...props} className="mb-2" />,
  strong: ({ node: _node, ...props }) => <strong {...props} className="font-semibold" />,
  table: ({ node: _node, ...props }) => (
    <div className="mb-2 max-w-full overflow-x-auto last:mb-0">
      <table {...props} className="w-full border-collapse text-[13px] leading-[20px] [overflow-wrap:normal]" />
    </div>
  ),
  th: ({ node: _node, ...props }) => (
    <th {...props} className="border border-innoveraZinc-150 bg-innoveraZinc-50 px-2 py-1 text-left font-semibold" />
  ),
  td: ({ node: _node, ...props }) => <td {...props} className="border border-innoveraZinc-150 px-2 py-1 align-top" />,
  pre: ({ node: _node, ...props }) => (
    <pre
      {...props}
      className="mb-2 max-w-full overflow-x-auto rounded-md bg-innoveraZinc-50 p-2 text-[12px] leading-[18px] last:mb-0 [&_code]:bg-transparent [&_code]:p-0"
    />
  ),
  code: ({ node: _node, ...props }) => <code {...props} className="rounded bg-innoveraZinc-100 px-1 py-0.5 text-[13px]" />
};

// A single "~" is ordinary text in financial answers ("~$4M"), so only "~~" strikes through.
const remarkPlugins: Options["remarkPlugins"] = [[remarkGfm, { singleTilde: false }]];

export function MessageMarkdown({ content }: { content: string }) {
  return (
    <div className="w-full min-w-0 text-[14px] leading-[22px] text-innoveraZinc-900 [overflow-wrap:anywhere]">
      <ReactMarkdown remarkPlugins={remarkPlugins} rehypePlugins={[rehypeRaw]} components={markdownComponents}>
        {content || ""}
      </ReactMarkdown>
    </div>
  );
}
